import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import { PieChart } from "react-minimal-pie-chart";
import {
  getLang,
  getRouting,
  digitToRupeeNotation,
} from "../../../../../utils/common";
import { NumericFormat } from "react-number-format";
import formulajs from "@formulajs/formulajs";

const CostOfChildEducation = (props) => {
  const {
    childData,
  } = props;

  const [clickedItem, setClickedItem] = useState(null);
  const [courseNameChild, setcourseNameChild] = useState('');
  const [noofYrstofullfill, setnoofYrstofullfill] = useState(1);
  const [rrexpectInvestments, setrrexpectInvestments] = useState(8);
  const [estimateCost, setestimateCost] = useState(0);
  const [totalSIP, settotalSIP] = useState(0);
  const [costAssuming, setcostAssuming] = useState(0);
  const [totalPiePercent, settotalPiePercent] = useState(0);

  const [amountErr, setamountErr] = useState(false);
  const [rateErr, setrateErr] = useState(false);
  const [timeErr, settimeErr] = useState(false);

  const handlenoofYrstofullfill = (event) => {
    const re = /^[0-9.\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === "" || re.test(event.target.value)) {
      if (event.target.value > 30 || event.target.value < 1) {
        setnoofYrstofullfill(event.target.value);
        settimeErr(true);
        //const totalSipValue = inflationCalculator(monthAmount, 1, yearExpense);
      } else {
        setnoofYrstofullfill(event.target.value);
        settimeErr(false);
      }
    }
  };

  const handlerrexpectInvestments = (event) => {
    const re = /^[0-9.\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === "" || re.test(event.target.value)) {
      if (event.target.value > 30 || event.target.value < 2) {
        setrrexpectInvestments(event.target.value);
        setrateErr(true);
        //const totalSipValue = inflationCalculator(monthAmount, 1, yearExpense);
      } else {
        setrrexpectInvestments(event.target.value);
        setrateErr(false);
        const totalSipValue = costChildEducalc(
          estimateCost,
          event.target.value,
          noofYrstofullfill
        );
        settotalSIP(Math.round(totalSipValue));
      }
    }
  };

  const handleEstimatecost = (event) => {
    const totalEstimateCost = parseFloat(event.target.value.replace(/,/g, ""));

    if (totalEstimateCost > 50000000 || totalEstimateCost < 1000) {
      setestimateCost(totalEstimateCost);
      setamountErr(true);
    } else {
      setestimateCost(totalEstimateCost);
      setamountErr(false);
      const totalSipValue = costChildEducalc(
        totalEstimateCost,
        rrexpectInvestments,
        noofYrstofullfill
      );
      settotalSIP(Math.round(totalSipValue));
    }
  };

  const handleEduName = (event, e) => {
    const total = event.years * event.cost;
    setestimateCost(total);
    const totalSipValue = costChildEducalc(
      total,
      rrexpectInvestments,
      noofYrstofullfill
    );
    settotalSIP(Math.round(totalSipValue));
    e.preventDefault();
    let selectedTag = e ? parseInt(event.indexVal, 10) : null;
    setClickedItem(selectedTag);
    setcourseNameChild(event.courseName);
  };

  function costChildEducalc(
    estimateCost,
    rrexpectInvestments,
    noofYrstofullfill
  ) {
    let timePeriod = 12,
      i = rrexpectInvestments / (timePeriod * 100),
      n = noofYrstofullfill * timePeriod;
    let totalAmount = Math.ceil(
      estimateCost * Math.pow(1.07, noofYrstofullfill)
    );
    setcostAssuming(Math.round(totalAmount));
    let newPercentValue = 12 * (Math.pow(1 + rrexpectInvestments/100, 1/12) - 1)  // new percent value
    let returnValue = formulajs.PMT(newPercentValue/12,noofYrstofullfill*12,0,totalAmount,1) * -1;

    const totalPieValue = Math.round(totalAmount) + Math.round(returnValue);

    settotalPiePercent(Math.round(totalPieValue));

    return Math.round(returnValue);
  }

  let smallPie = "";
  let bigPie = "";
  if (amountErr === false && rateErr === false && timeErr === false) {
    smallPie = (costAssuming / totalPiePercent) * 100;
    bigPie = (totalSIP / totalPiePercent) * 100;
  } else {
    smallPie = 0;
    bigPie = 0;
  }

  return (
    <section className="inflationtoolsdiv">
      <div className="container pb-md-5">
        <div className="row my-5 gx-5">
          <div className="col-md-6 mb-4">
            <div className="toolsfirstdiv me-md-3">
              <h2 className="mb-3"><span>Cost of Child</span> education</h2>
              <p className="mb-4">
                Child education is the most important thing. Find out how much
                you will need to invest in your child’s future education.
              </p>
              <div className="mb-4">
                <div className="align-items-center mb-3 row">
                  <div className="col-7 text-break">
                    <h4>Number of years to fulfill this goal</h4>
                  </div>
                  <div className="col-5 d-flex justify-content-end">
                    <input
                      type="text"
                      className="amtwidth"
                      placeholder="Enter Years"
                      value={noofYrstofullfill}
                      onChange={handlenoofYrstofullfill}
                      maxLength={2}
                    />
                  </div>
                  <div className="col-8">&nbsp;</div>
                  {timeErr ? (
                    <div className="col-12 d-flex justify-content-end errortext">
                      <span style={{ color: "red", fontSize: 12 }}>
                        Value should be between 1 - 30
                      </span>
                    </div>
                  ) : null}
                </div>
                <div>
                  <input
                    type="range"
                    className="w-100"
                    min="1"
                    max="30"
                    value={noofYrstofullfill}
                    onChange={handlenoofYrstofullfill}
                  />
                  <div className="d-flex justify-content-between startendval">
                    <span>1 Years</span>
                    <span>30 Years</span>
                  </div>
                </div>
              </div>
              <div className="coursename">
                <h4>The course I would like to start saving for</h4>
                <div className="row mt-3">
                  {childData &&
                    childData.length > 0 &&
                    childData.map((item, index) => (
                      <div className="mb-4 col-2">
                        <div
                          key={index}
                          id={index}
                          className={"d-flex flex-column"}
                          onClick={(e) =>
                            handleEduName(
                              {
                                years: item.numberOfYears,
                                cost: item.perYearCost,
                                indexVal: index,
                                courseName: item.name
                              },
                              e
                            )
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <div
                            className={
                              index === clickedItem
                                ? "is-checked iconbg d-flex align-items-center justify-content-center p-2"
                                : "iconbg d-flex align-items-center justify-content-center p-2"
                            }
                          >
                            <img src={item && item.classIcon} />
                          </div>
                          <p className="coursetext">{item.name}</p>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
              <div className="mb-5">
                <div className="align-items-center row">
                  <div className="col-7 text-break">
                    <h4>Estimate cost</h4>
                  </div>
                  <div className="col-5 d-flex justify-content-end">
                    {/* <span className='amount'></span> */}
                    <NumericFormat
                      type="text"
                      className="amtwidth"
                      value={estimateCost}
                      onInput={handleEstimatecost}
                      placeholder="₹ 0"
                      thousandSeparator={","}
                      thousandsGroupStyle="lakh"
                      decimalSeparator={"."}
                    />
                  </div>
                  <div className="col-8">&nbsp;</div>
                  {amountErr ? (
                    <div className="col-12 d-flex justify-content-end errortext">
                      <span style={{ color: "red", fontSize: 12 }}>
                        Value should be between 1,000 - 5,00,00,000
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="mb-4">
                <div className="align-items-center mb-3 row">
                  <div className="col-7 text-break">
                    <h4>Rate of return I expect on my investments</h4>
                  </div>
                  <div className="col-5 d-flex justify-content-end">
                    <input
                      type="text"
                      className="amtwidth"
                      placeholder="0 %"
                      value={rrexpectInvestments}
                      onChange={handlerrexpectInvestments}
                      maxLength={2}
                    />
                  </div>
                  <div className="col-8">&nbsp;</div>
                  {rateErr ? (
                    <div className="col-12 d-flex justify-content-end errortext">
                      <span style={{ color: "red", fontSize: 12 }}>
                        Value should be between 2 - 30
                      </span>
                    </div>
                  ) : null}
                </div>
                <div>
                  <input
                    type="range"
                    className="w-100"
                    min="2"
                    max="30"
                    value={rrexpectInvestments}
                    onChange={handlerrexpectInvestments}
                  />
                  <div className="d-flex justify-content-between startendval">
                    <span>2 %</span>
                    <span>30 %</span>
                  </div>
                </div>
              </div>
            </div>
            {smallPie && bigPie ? (
              <div className="currentandfuture">
                <div className="row">
                  <div className="col-6">
                    <p className="text">
                      Total Cost<span> Assuming 7% rate of inflation</span>
                    </p>
                    <p className="cfamount my-2">
                      ₹ {digitToRupeeNotation(costAssuming)}
                    </p>
                  </div>
                  <div className="col-6">
                    <p className="text">Save/month</p>
                    <p className="cfamount my-2">
                      ₹ {isNaN(totalSIP) ? "0" : digitToRupeeNotation(totalSIP)}
                    </p>
                  </div>
                </div>
                {/* <FundReviewRecommendations /> */}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="col-md-6 mb-4">
            <div className="ms-md-3">
              <div className="w-50 w-50 mx-auto mb-4">
                <PieChart
                  data={[
                    {
                      title: "Cost Assuming",
                      value: smallPie,
                      color: "rgba(27, 75, 134)",
                    },
                    {
                      title: "Save/month",
                      value: bigPie,
                      color: "rgba(27, 75, 134,0.7)",
                    },
                  ]}
                  lineWidth={35}
                />
              </div>
            </div>
            {smallPie && bigPie ? (
              <div className="row justify-content-center my-4">
                <div className="col-md-9">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="piecolor"></div>
                      <p>Save/month</p>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="piecolor1"></div>
                      <p>Cost Assuming</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CostOfChildEducation;
